"use client"

import { ChevronDown } from "lucide-react"

import { useIsMobile } from "@/hooks/use-is-mobile"
import { LocationSelector } from "@/features/location-selector"
import { useLocation } from "@/features/location-selector/hooks"
import { useLocationDialogs } from "@/features/location-selector/hooks/use-location-dialogs"

import { HomeMobileSearch } from "./home-mobile-search"
import { MobileHotKeywords } from "./mobile-hot-keywords"

export function HomeMobileControl() {
  const isMobile = useIsMobile()
  const { address } = useLocation()
  const { openLocationDialog } = useLocationDialogs()

  if (!isMobile) return null

  return (
    <div className="px-5 py-3 flex flex-col gap-3">
      <button
        className="flex flex-col gap-0.5 text-left"
        onClick={openLocationDialog}
        aria-label="Thay đổi địa chỉ giao hàng"
      >
        <span className="text-xs text-gray-500">Giao đến</span>
        <div className="text-sm font-medium flex items-center gap-1">
          <span className="line-clamp-2">
            {address?.display || "Thay đổi địa chỉ"}
          </span>
          <ChevronDown className="w-3 h-3 flex-shrink-0" />
        </div>
      </button>

      <HomeMobileSearch hotKeywords={<MobileHotKeywords />} />

      {/* This is needed to render the location dialog */}
      <div className="hidden">
        <LocationSelector />
      </div>
    </div>
  )
}
